import axios from 'axios';
import CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';
import * as JSTool from './JSTool';
import { settingObj } from './SettingSlice';
import country from './country.json';


const RequestCache = {};

function getHost() {
    if (JSTool.isCR()) {
        return "https://am-web-api.aplus-games.com";
    }
    return "https://eu-web-api.aplus-games.com";
}

function getGameId() {
    if (JSTool.isCR()) {
        return "bpsr_cr";
    }
    return 'bpsr_apj';
}

//-------------APJ 后台接口-------------
//发送验证码
export function sendEmailCode(email, onSuccess, onFail) {
    post_apj('/api/client/email/check',
        {
            email: email,
            gameid: getGameId()
        }, onSuccess, onFail);
}

//添加邮件
export function addEmail(email, code, onSuccess, onFail) {
    post_apj('/api/client/email/record',
        {
            email: email,
            code: code,
            gameid: getGameId()
        }, onSuccess, onFail);
}

//添加邮件 无验证码
export function addEmail_noCode(email, onSuccess, onFail) {
    post_apj('/api/client/email/add',
        {
            email: email,
            gameid: getGameId()
        }, onSuccess, onFail);
}

//最新新闻列表
export function getNewsLatest(num, onSuccess, onFail) {
    post_apj('/api/client/web/news/latest', { num: num }, (data) => { onSuccess(data.data) }, onFail);
}

//新闻列表分页
export function getNewsPage(pageIndex, pageNum, onSuccess, onFail) {
    post_apj('/api/backend/web/news/list', { pageIndex: pageIndex, pageNum: pageNum }, (data) => { onSuccess(data.data) }, onFail);
}

//新闻详情
export function getNewsDetail(newsId, onSuccess, onFail) {
    post_apj('/api/client/web/news/detail', { id: parseInt(newsId) }, (data) => {
        onSuccess(data.content);
    }, onFail);
}

export function post_apj(path, param, onSuccess, onFail) {
    let key = CryptoJS.MD5(getHost() + path + mapToQueryString(param)).toString();
    if (RequestCache.hasOwnProperty(key) && !(path.indexOf('email') != -1)) {
        // console.log('使用缓存：');
        // console.log(RequestCache[key]);
        onSuccess(RequestCache[key]);
        return;
    }

    axios.post(getHost() + path, param, {
        headers: {
            'Content-Type': 'application/json'
        },
    }).then(({ data }) => {
        if (100000 == data.code) { //成功
            onSuccess(data.data);
        } else {
            onFail(data.code, data.data.message);
        }
    }).catch(function (error) {
        console.log(error);
        onFail(-1000, 'Request fialed, please try again later');
    });
}


function mapToQueryString(map) {
    if (map == null) {
        return '';
    }

    const paramsArray = [];
    const sortedKeys = Object.keys(map).sort((a, b) => a.localeCompare(b));
    for (const key of sortedKeys) {
        let x = map[key];
        if (x == null) {
            x = '';
        } else if (Array.isArray(x)) {
            x = x.join(',');
        }
        paramsArray.push(`${key}=${x}`);
    }
    return paramsArray.join('&');
}


const allowedIPList = ["118.242.32.210", "182.255.32.49", "103.116.72.4", "23.249.17.72"];

export function getIPInfo(onResult) {
    axios.post(JSTool.isCR() ? 'https://am-web-api.aplus-games.com/api/public/geoip' : 'https://eu-web-api.aplus-games.com/api/public/geoip', {
        headers: {},
    }).then(({ data }) => {
        if (data.ip) { //成功
            const ip = data.ip;
            const countryCode = data.country_code;

            if (isPass(allowedIPList, ip)) { //白名单
                onResult(true);
                return;
            }

            if (country['forbidden'].indexOf(countryCode) != -1) { //禁用国家
                onResult(false)
            } else {
                onResult(true)
            }

        } else {
            onResult(false);
        }
    }).catch(function (error) {
        console.log(error);
        onResult(false);
    });
}

function isPass(ary, code) {
    var ret = false;
    for (var i = 0; i < ary.length; i++) {
        if (ary[i].toUpperCase() == code.toUpperCase()) {
            ret = true;
            break;
        }
    }
    return ret;
}